
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.319 10.693c-.827 0-1.5.673-1.5 1.5v2.974c0 .827.673 1.5 1.5 1.5h2.975c.827 0 1.5-.673 1.5-1.5v-2.974c0-.827-.673-1.5-1.5-1.5H4.319zm3.475 1.5v2.974c0 .275-.225.5-.5.5H4.319a.501.501 0 01-.5-.5v-2.974c0-.275.225-.5.5-.5h2.975c.275 0 .5.225.5.5zm3.276-1.5a.5.5 0 000 1h3.396a.5.5 0 000-1H11.07zm0 3.488h.524a.5.5 0 000-1h-.524a.5.5 0 000 1z"}}),_c('path',{attrs:{"d":"M22.328 3.764H19.17V2.738A1.938 1.938 0 0017.235.802H1.905C.855.802 0 1.657 0 2.708v18.31c0 1.202.978 2.179 2.18 2.179h9.593a.5.5 0 000-1H2.18c-.65 0-1.18-.529-1.18-1.18V2.708c0-.5.406-.906.905-.906h15.33c.516 0 .935.42.935.936v7.445a.5.5 0 001 0V4.764h3.158c.37 0 .672.301.672.671v7.918a.5.5 0 001 0V5.435c0-.921-.75-1.671-1.672-1.671z"}}),_c('path',{attrs:{"d":"M16.221 7.773a.5.5 0 00-.5-.5H3.356a.5.5 0 000 1h12.365a.5.5 0 00.5-.5zm5.114 12.845c.756-.914 1.229-2.07 1.229-3.346 0-2.912-2.369-5.281-5.282-5.281s-5.281 2.369-5.281 5.281 2.369 5.282 5.281 5.282c1.276 0 2.432-.473 3.346-1.229l2.519 2.519a.498.498 0 00.708 0 .5.5 0 000-.707l-2.519-2.519zm-8.334-3.346c0-2.36 1.921-4.281 4.281-4.281s4.282 1.921 4.282 4.281-1.921 4.282-4.282 4.282-4.281-1.921-4.281-4.282z"}})])
          )
        }
      }
    